"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.PreDefinedMessagesWrapper = exports.ActionWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var PreDefinedMessagesWrapper = exports.PreDefinedMessagesWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  transition-property: opacity, height;\n  transition-duration: var(--transition-delay-5);\n  transition-timing-function: ease-out;\n  height: ", ";\n  opacity: ", ";\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n"])), function (_ref) {
  var isKeyboardOpen = _ref.isKeyboardOpen;
  return isKeyboardOpen ? '16px' : '63px';
}, function (_ref2) {
  var isKeyboardOpen = _ref2.isKeyboardOpen;
  return isKeyboardOpen ? '0' : '1';
});
var Wrapper = exports.Wrapper = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  border-color: var(--color-neutral-90);\n  border-style: solid;\n  border-width: var(--border-width-hairline) 0 0 0;\n  gap: var(--spacing-2);\n  position: relative;\n\n  @media (min-width: 840px) {\n    justify-content: ", ";\n  }\n"])), function (_ref3) {
  var isAdview = _ref3.isAdview;
  return isAdview ? 'center' : 'flex-start';
});
var ActionWrapper = exports.ActionWrapper = (0, _styledComponents["default"])(Wrapper)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: var(--spacing-2);\n"])));